<template>
    <form method="GET" :action="searchEndpointUri">
        <div class="d-flex flex-wrap flex-sm-nowrap">
            <input type="search" id="query" name="q" class="form-control mb-2 mb-sm-0 mr-1" v-model="query" :placeholder="placeholder">

            <slot name="search-button">
                <button type="submit" id="submit-query" class="btn btn-primary mr-2 mb-2 mb-sm-0">
                    <img src="/img/ico-suche.svg" alt="" /> <!--{{ translate('label.nav.search') }}-->
                </button>
            </slot>

            <slot name="reset-button">
                <button @click.prevent="onReset" class="btn btn-light mb-2 mb-sm-0">
                    Reset
                </button>
            </slot>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            searchEndpointUri: { type: String, required: true },
            searchQuery: { type: String, required: true },
            placeholder: { type: String, default: '' }
        },

        data() {
            return {
                query: this.searchQuery
            }
        },

        methods: {
            onReset() {
                this.query = '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    #query {
        height: 2.25rem;
        font-size: 1rem;
        &:focus {
            background-color: #fff;
            color:#000;
            border-color: lighten($color: #96abae, $amount: 10);
            box-shadow: 0 0 0 0.1rem darken($color: #96abae, $amount: 10);
        }
    }
    #submit-query {
        height: 2.25rem;
        height: 2.25rem;
        font-size: 0.875rem;
        background-color: lighten($color: #96abae, $amount: 10);
        border: 1px solid rgba(0, 0, 0, 0.125);
        &:focus {
            background-color: lighten($color: #96abae, $amount: 20);
            border-color: lighten($color: #96abae, $amount: 10);
            box-shadow: 0 0 0 0.1rem darken($color: #96abae, $amount: 10);
        }
        &:hover {
            background-color:#fff;
        }
    }
</style>
